import { createTheme, Theme } from '@mui/material/styles';

export const formPreviewThemeFactory = (parentTheme: Theme): Theme =>
  createTheme(parentTheme, {
    components: {
      MuiInputBase: {
        styleOverrides: {
          root: {
            '&.Mui-disabled': {
              color: parentTheme.palette.text.primary,
              WebkitTextFillColor: parentTheme.palette.text.primary,
              WebkitOpacity: 1,
            },
          },
        },
      },
      MuiIconButton: {
        styleOverrides: {
          root: {
            '&.Mui-disabled': {
              color: parentTheme.palette.text.secondary,
            },
          },
        },
      },
      MuiFormControlLabel: {
        styleOverrides: {
          label: {
            '&.Mui-disabled': {
              color: parentTheme.palette.text.primary,
            },
          },
        },
      },
      MuiFormHelperText: {
        styleOverrides: {
          root: {
            marginTop: '8px',
            minHeight: '1em',
          },
        },
      },
    },
  });
